/* global localStorage:false */
(function () {
  "use strict";

  angular
    .module("admin.post.comments", ["admin.comments.service"])
    .controller("PostCommentsAdminCtrl", PostCommentsAdminCtrl);

  /** @ngInject */
  function PostCommentsAdminCtrl(
    $scope,
    $stateParams,
    $state,
    CommentsAdminService
  ) {
    var vm = this;
    vm.create = false;
    vm.items = [];
    vm.sort = "ts-desc";
    vm.options = [
      { value: "ts-desc", label: "Newest" },
      { value: "ts-asc", label: "Oldest" },
    ];

    function reloadPagination() {
      vm.totalUsers = 0;
      vm.usersPerPage = 25;
      vm.oldPage = 0;
      vm.currentPage = 25;
      vm.first = true;
      vm.totalItems = 0;
      vm.pagination = {
        current: 1,
      };
    }

    vm.back = function () {
      if ($stateParams.returnUrl) {
        window.location = $stateParams.returnUrl;
      } else {
        $state.go("admin.posts");
      }
    };

    reloadPagination();
    load(1);

    function load(pageNumber) {
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      } else {
        vm.first = false;
      }

      CommentsAdminService.list(
        $stateParams.parentId,
        vm.oldPage,
        25,
        vm.sort
      ).then(function (result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }

        for (var i = 0; i < result.results.length; i++) {
          result.results[i].editing = false;
          if (result.results[i]["ts"] !== undefined) {
            result.results[i]["ts"] = new Date(
              parseInt(
                result.results[i]["ts"]
                  .toString()
                  .substring(0, result.results[i]["ts"].toString().length - 3)
              )
            );
          }
        }
        vm.items = result.results;
      });
    }

    vm.pageChanged = function (newPage) {
      load(newPage);
    };

    vm.reload = function () {
      reloadPagination();
      load(1);
    };

    vm.add = function () {
      vm.items.unshift({
        id: 0,
        txt: "",
        "id-po": parseInt($stateParams.parentId),
        editing: true,
      });
      vm.create = true;
    };

    vm.edit = function (item) {
      item.editing = !item.editing;
    };

    vm.save = function (item) {
      vm.create = false;
      if (item.id !== undefined && item.id !== "" && item.id !== 0) {
        CommentsAdminService.update($stateParams.parentId, item.id, {
          txt: item.txt,
        }).then(
          function () {
            reloadPagination();
            load(vm.pagination.current);
          },
          function (err) {
            swal(err.error.message, "", "error");
          }
        );
      } else {
        CommentsAdminService.save($stateParams.parentId, item).then(
          function () {
            reloadPagination();
            load(vm.pagination.current);
          },
          function (err) {
            swal(err.error.message, "", "error");
          }
        );
      }
    };

    vm.cancel = function (item) {
      if (vm.create) {
        vm.items.remove(item);
      }

      vm.create = false;
      item.editing = !item.editing;
    };

    vm.delete = function (item) {
      swal(
        {
          title: "Delete Comment",
          text: "Are you sure ?",
          type: "warning",
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: "slide-from-top",
        },
        function (isConfirm) {
          if (isConfirm) {
            CommentsAdminService.remove($stateParams.parentId, item.id).then(
              function () {
                reloadPagination();
                load(vm.pagination.current);
              },
              function (err) {
                swal(err.error.message, "", "error");
              }
            );
          } else {
            return;
          }
        }
      );
    };

    vm.hidden = function (item) {
      var hide = item.h === true ? false : true;
      CommentsAdminService.hide(item.id).then(
        function () {
          reloadPagination();
          load(vm.pagination.current);
        },
        function (err) {
          swal(err.error.message, "", "error");
        }
      );
    };

    vm.clearReport = function (item) {
      swal(
        {
          title: "Clear Report",
          text: "This action will clean up all reports for this comment. Are you sure?",
          type: "warning",
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: "slide-from-top",
        },
        function (isConfirm) {
          if (isConfirm) {
            CommentsAdminService.clearReport(item.id).then(
              function () {
                reloadPagination();
                load(vm.pagination.current);
              },
              function (err) {
                swal(err.error.message, "", "error");
              }
            );
          }
        }
      );
    };

    vm.unhidden = function (item) {
      swal(
        {
          title: "Unhidden",
          text: "This action will unhidden. Are you sure?",
          type: "warning",
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: "slide-from-top",
        },
        function (isConfirm) {
          if (isConfirm) {
            CommentsAdminService.unhidden(item["id-u"]).then(
              function () {
                reloadPagination();
                load(vm.pagination.current);
              },
              function (err) {
                swal(err.error.message, "", "error");
              }
            );
          }
        }
      );
    };

    vm.block = function (item) {
      swal(
        {
          title: "Block",
          text: "This action will block. Are you sure?",
          type: "warning",
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: "slide-from-top",
        },
        function (isConfirm) {
          if (isConfirm) {
            CommentsAdminService.block(item["id-po"], item["id-u"]).then(
              function () {
                reloadPagination();
                load(vm.pagination.current);
              },
              function (err) {
                swal(err.error.message, "", "error");
              }
            );
          }
        }
      );
    };

    vm.unblock = function (item) {
      swal(
        {
          title: "Unblock",
          text: "This action will unblock. Are you sure?",
          type: "warning",
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: "slide-from-top",
        },
        function (isConfirm) {
          if (isConfirm) {
            CommentsAdminService.unblock(item["id-po"], item["id-u"]).then(
              function () {
                reloadPagination();
                load(vm.pagination.current);
              },
              function (err) {
                swal(err.error.message, "", "error");
              }
            );
          }
        }
      );
    };

    vm.report = function (item) {
      CommentsAdminService.report(item.id).then(
        function () {
          reloadPagination();
          load(vm.pagination.current);
        },
        function (err) {
          swal(err.error.message, "", "error");
        }
      );
    };
  }
})();
